<template>
  <!-- eslint-disable vue/no-v-html -->
  <Locales v-slot="{ list, current, change }">
    <Menu
      v-slot="{ open }"
      as="div"
      class="relative ml-2 md:ml-4 inline-block text-left"
    >
      <div>
        <!-- A plain globe instead of the flag (the sign-in pages' glass card). -->
        <MenuButton
          v-if="icon"
          class="flex size-9 items-center justify-center rounded-full text-(--ds-text-secondary) transition-colors duration-150 hover:bg-(--ds-surface-subtle) hover:text-(--ds-text-primary) [&>svg]:size-5"
          :aria-label="$t('common.language')"
          :title="$t('common.language')"
          data-test="language-globe"
        >
          <span
            class="flex [&>svg]:size-5"
            aria-hidden="true"
            v-html="ICONS.globe"
          />
        </MenuButton>
        <MenuButton
          v-else
          class="w-5 rounded-control py-[5px] text-primary"
          :class="{
            'text-white': open,
          }"
        >
          <img
            :src="Vapor.asset(`images/flags/${current.code}.gif`)"
            alt="flag-img"
            class="w-5 h-5 rounded-full border-2 border-primary mx-auto"
          />
        </MenuButton>
      </div>

      <Transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <MenuItems
          :class="[
            'absolute right-0 z-10 mt-2 min-w-[200px] origin-top-right overflow-hidden rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5',
            dropdownClass,
          ]"
        >
          <p
            role="heading"
            aria-level="2"
            class="text-[#3f1e59] text-tiny font-bold uppercase tracking-[1px] py-2 px-4 mb-1"
            v-text="$t('common.language')"
          />
          <MenuItem
            v-for="{ code, label } in list"
            :key="code"
            v-slot="{ active }"
          >
            <div
              :class="[
                active || code === current.code
                  ? 'text-primary'
                  : 'text-gray-700',
                'block cursor-pointer px-4 py-2 text-sm font-medium hover:underline data-focus:underline focus:underline focus-within:underline',
              ]"
              @click="change(code)"
              v-text="label"
            />
          </MenuItem>
        </MenuItems>
      </Transition>
    </Menu>
  </Locales>
</template>

<script setup>
import Locales from '@/Components/Headless/Locales'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ICONS } from '@/Libraries/design-system-icons'
import Vapor from 'laravel-vapor'

defineProps({
  dropdownClass: {
    type: [String, Array, Object],
    default: '',
  },
  /** Show a globe icon (a design-system static SVG) instead of the current language's flag. */
  icon: {
    type: Boolean,
    default: false,
  },
})
</script>
